import React, { useState } from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TableRow,
    Table,
    TableHead,
    TableBody,
    TableCell,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Card,
    Box,
    TableContainer,
    Paper,
    Typography,
} from "@material-ui/core";
import TeacherService from "./Locality/Service/teacherService";
import * as Yup from 'yup';
import { Grid, TextField, IconButton, InputAdornment } from "@material-ui/core";
import { useFormik } from 'formik';
import { useEffect } from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import EditIcon from '@material-ui/icons/Edit';
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import AddClassService from "./Locality/Service/addClassService";
import SectionService from "./Locality/Service/sectionService";
const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#0f3b62ad",
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);
const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
}));
export default function Teacher() {
    const tableHeaders = ['Teacher Name', 'Class', 'Section', 'Address', 'Status', 'Assign Class', 'Edit', 'Delete', 'Transfer'];
    const classes = useStyles();
    const [teacherList, setTeacherList] = useState([]);
    const [age, setAge] = React.useState('');
    const [teacherIdList, setTeacherIdList] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [teacher, setTeacher] = useState({
        teacherName: '',
         email: '',
        password: '',
        qualification: '',
        address: '',
        mobileNumber: '',
        classId: '',
        sectionId: '',
        status: 'active',
    })
    
               var [searchClassId, setSearchClassId] = useState("");
    
     const [isEditMode, setIsEditMode] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [addClassList, setAddClassList] = useState([]);
    const [sectionList, setSectionList] = useState([]);
    const [transferOpen, setTransferOpen] = useState(false);
    const [transferFromTeacher, setTransferFromTeacher] = useState(null);
    const [transferClassId, setTransferClassId] = useState('');
    const [transferToTeacherId, setTransferToTeacherId] = useState('');
    // State for assigning multiple classes/sections to a teacher
    const [assignOpen, setAssignOpen] = useState(false);
    const [assignTeacher, setAssignTeacher] = useState(null);
    const [assignClassId, setAssignClassId] = useState('');
    const [assignSectionIds, setAssignSectionIds] = useState([]);
    const [assignSectionList, setAssignSectionList] = useState([]);
    const [assignments, setAssignments] = useState([]);
    const [assignEditingIndex, setAssignEditingIndex] = useState(null);
    const validationSchema = Yup.object().shape({
        teacherName: Yup.string().required('Teacher name is required'),
        classId: Yup.string(),
        email: Yup.string(),
        password: Yup.string().when('_id', {
            is: (val) => !!val,
            then: (schema) => schema.notRequired(),
            otherwise: (schema) => schema.required('Password is required'),
        }),
        qualification: Yup.string(),
        address: Yup.string(),
        status: Yup.string()
            .oneOf(['active', 'inactive'], 'Status must be Active or Inactive')
            .required('Status is required'),
        mobileNumber: Yup.string().required('Mobile number is required')
            .matches(/^[0-9]+$/, "Must be only digits")
            .min(10, 'Must be exactly 10 digits')
            .max(10, 'Must be exactly 10 digits'),
    });
    useEffect(() => {
        getTeacherList();
        getAddClassList();
        return () => {
            setTeacherIdList([]);
            setTeacherList([]);
        }
    }, []);
    const handleOpen = (status) => {
        if (status) {
            setTeacher({
                teacherName: '',
                 email: '',
                password: '',
                qualification: '',
                address: '',
                mobileNumber: '',
                classId: '',
                status: 'active',
            })
        }

        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const handleClickShowPassword = () => {
        setShowPassword((prev) => !prev);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    const getAddClassList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
        AddClassService.getAllAddClass(userDetails.schooleId)
            .then((res) => {
                // de-duplicate by className just in case
                const list = Array.isArray(res) ? res : [];
                const map = new Map();
                for (const item of list) {
                    const key = String(item?.className || "").trim().toLowerCase();
                    if (!key) continue;
                    if (!map.has(key)) map.set(key, item);
                }
                const unique = Array.from(map.values()).sort((a, b) =>
                    String(a?.className || "").localeCompare(String(b?.className || ""))
                );
                setAddClassList(unique);
            })
            .catch(() => {
                setAddClassList([]);
            });
    }

    const getSectionListByClass = (classId) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
        if (!classId) {
            setSectionList([]);
            return;
        }
        SectionService.findSectionList({
            schooleId: userDetails.schooleId,
            classId,
        })
            .then((res) => {
                setSectionList(Array.isArray(res) ? res : []);
            })
            .catch(() => {
                setSectionList([]);
            });
    };
    // Load sections for Assign Class dialog based on selected class
    const getAssignSectionListByClass = (classId) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
        if (!classId) {
            setAssignSectionList([]);
            return;
        }
        SectionService.findSectionList({
            schooleId: userDetails.schooleId,
            classId,
        })
            .then((res) => {
                setAssignSectionList(Array.isArray(res) ? res : []);
            })
            .catch(() => {
                setAssignSectionList([]);
            });
    };
    // const getStudentList = () => {
    //     const userDetails = JSON.parse(localStorage.getItem("userDetail"));
    //     StudentService.getAllStudent(userDetails.schooleId).then((res) => {
    //      const mapResult =   res.map((student)=>{
    //             return {...student,fullName:`${student.firstName} ${student.lastName} `}
    //         })
    //         setStudentList(mapResult);
    //     }).catch((err) => {
    //         console.error("Error fetching student list:", err);
    //     });
    // };
    const getTeacherList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        TeacherService.getAllTeacher(userDetails.schooleId).then((res) => {
            const mapResult =   res.map((teacher)=>{
                return {...teacher}
            })
            setTeacherList(mapResult);
            
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const onSubmit = data => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
      
        const keys = {
            'classId': searchClassId, 
        }
        TeacherService.findTeachertList(keys).then((res) => {
          
            const mapResult =   res.map((teacher)=>{
                return {...teacher}
            })
            setTeacherList(mapResult);
            // setStudentList(res);
        }).catch((err) => {
            console.error(err)
            // setError(err.message);
        });

    };
    const editTeacher = (rowTeacher) => {
        const teacherForForm = {
            ...rowTeacher,
            classId: rowTeacher.classId ? (rowTeacher.classId._id || rowTeacher.classId) : '',
            sectionId: rowTeacher.sectionId ? (rowTeacher.sectionId._id || rowTeacher.sectionId) : '',
            status: (rowTeacher.status === true || rowTeacher.status === 'active') ? 'active' : 'inactive',
        };
        if (teacherForForm.classId) {
            getSectionListByClass(teacherForForm.classId);
        } else {
            setSectionList([]);
        }
        setTeacher(teacherForForm);
        handleOpen(false);
        setIsEditMode(true);
    }
    const deleteTeacher = (teacherdelete) => {
        if (teacherdelete) {
            const teacherName = teacherdelete.teacherName || 'this teacher';
            const confirmMessage = `Are you sure you want to delete "${teacherName}"?\n\nThis action cannot be undone. All associated data will be permanently removed.`;
            
            if (window.confirm(confirmMessage)) {
                TeacherService.deleteTeacher(teacherdelete).then((res) => {
                    getTeacherList();
                    alert(`Teacher "${teacherName}" has been deleted successfully.`);
                }).catch((err) => {
                    alert(err?.response?.data?.message || `Failed to delete teacher "${teacherName}". Please try again.`);
                });
            }
        }
    };

    // ----- Assign Class & Section (additionalClassAndSection) -----
    const openAssignClassDialog = (rowTeacher) => {
        const existing = Array.isArray(rowTeacher.additionalClassAndSection)
            ? rowTeacher.additionalClassAndSection
            : [];

        const normalizedAssignments = existing.map((item) => {
            const cls = item && item.class ? item.class : {};
            const classId =
                (cls.classId && cls.classId._id) ||
                cls.classId ||
                (cls._id || "");
            const className = cls.className || (cls.classId && cls.classId.className) || "";

            const sections = Array.isArray(item.sectionId)
                ? item.sectionId.map((sec) => {
                    const sectionId =
                        (sec && sec.sectionId && sec.sectionId._id) ||
                        (sec && sec.sectionId) ||
                        (sec && sec._id) ||
                        "";
                    const sectionName =
                        (sec && sec.sectionName) ||
                        (sec && sec.sectionId && sec.sectionId.sectionName) ||
                        "";
                    return {
                        sectionId,
                        sectionName,
                    };
                  }).filter((s) => s.sectionId)
                : [];

            return {
                class: {
                    classId,
                    className,
                },
                sectionId: sections,
            };
        });

        setAssignTeacher(rowTeacher);
        setAssignments(normalizedAssignments);
        setAssignClassId("");
        setAssignSectionIds([]);
        setAssignSectionList([]);
        setAssignEditingIndex(null);
        setAssignOpen(true);
    };

    const handleAssignClose = () => {
        setAssignOpen(false);
        setAssignTeacher(null);
        setAssignClassId("");
        setAssignSectionIds([]);
        setAssignSectionList([]);
        setAssignEditingIndex(null);
    };

    const handleAssignClassChange = (event) => {
        const value = event.target.value;
        setAssignClassId(value);
        setAssignSectionIds([]);
        getAssignSectionListByClass(value);
    };

    const handleAssignSectionChange = (event) => {
        const value = event.target.value;
        setAssignSectionIds(typeof value === 'string' ? value.split(',') : value);
    };

    const handleAddOrUpdateAssignment = () => {
        if (!assignClassId) {
            alert("Please select a class before assigning.");
            return;
        }
        const selectedClass = addClassList.find((c) => (c._id === assignClassId));
        const className = selectedClass ? selectedClass.className : "";

        const nextAssignment = {
            class: {
                classId: assignClassId,
                className,
            },
            sectionId: (assignSectionIds || []).map((id) => {
                const sec = assignSectionList.find((s) => s._id === id);
                return {
                    sectionId: id,
                    sectionName: (sec && sec.sectionName) || "",
                };
            }),
        };

        setAssignments((prev) => {
            const copy = [...prev];
            if (assignEditingIndex != null && assignEditingIndex > -1 && assignEditingIndex < copy.length) {
                copy[assignEditingIndex] = nextAssignment;
            } else {
                // prevent exact duplicate class+sections combination
                const exists = copy.some((item) => {
                    const sameClass = String(item.class.classId) === String(nextAssignment.class.classId);
                    const existingSecIds = (item.sectionId || []).map((s) => String(s.sectionId)).sort().join(',');
                    const nextSecIds = (nextAssignment.sectionId || []).map((s) => String(s.sectionId)).sort().join(',');
                    return sameClass && existingSecIds === nextSecIds;
                });
                if (!exists) {
                    copy.push(nextAssignment);
                }
            }
            return copy;
        });

        setAssignClassId("");
        setAssignSectionIds([]);
        setAssignSectionList([]);
        setAssignEditingIndex(null);
    };

    const handleEditAssignment = (index) => {
        const item = assignments[index];
        if (!item) return;

        const classId = item.class && (item.class.classId || (item.class._id));
        setAssignClassId(classId || "");
        const secIds = Array.isArray(item.sectionId)
            ? item.sectionId.map((s) => s.sectionId || (s._id || ""))
            : [];
        setAssignSectionIds(secIds);
        if (classId) {
            getAssignSectionListByClass(classId);
        } else {
            setAssignSectionList([]);
        }
        setAssignEditingIndex(index);
    };

    const handleDeleteAssignment = (index) => {
        setAssignments((prev) => prev.filter((_, i) => i !== index));
    };

    const handleAssignSave = () => {
        if (!assignTeacher) {
            return;
        }
        TeacherService.updateAdditionalClassAndSection(assignTeacher._id, {
            additionalClassAndSection: assignments,
        })
            .then((res) => {
                handleAssignClose();
                getTeacherList();
                alert(res?.data?.message || "Additional classes/sections updated successfully.");
            })
            .catch((err) => {
                alert(
                    err?.response?.data?.message ||
                    "Failed to update additional classes/sections."
                );
            });
    };

    const openTransferPopup = (rowTeacher) => {
        const classId = rowTeacher.classId ? (rowTeacher.classId._id || rowTeacher.classId) : '';
        if (!classId) return;
        setTransferFromTeacher(rowTeacher);
        setTransferClassId(classId);
        setTransferToTeacherId('');
        setTransferOpen(true);
    };

    const handleTransferClose = () => {
        setTransferOpen(false);
        setTransferFromTeacher(null);
        setTransferClassId('');
        setTransferToTeacherId('');
    };

    const handleTransferSubmit = () => {
        if (!transferToTeacherId || !transferFromTeacher) return;
        TeacherService.transferTeacher({
            fromTeacherId: transferFromTeacher._id,
            toTeacherId: transferToTeacherId,
            classId: transferClassId,
        }).then((res) => {
            handleTransferClose();
            getTeacherList();
            alert(res?.data?.message || 'Transfer completed successfully.');
        }).catch((err) => {
            alert(err?.response?.data?.message || 'Failed to transfer teacher data.');
        });
    };

    const teachersWithoutClass = teacherList.filter((t) => {
        const hasNoClass = !t.classId || (t.classId && !t.classId._id);
        const isNotFromTeacher = !transferFromTeacher || t._id !== transferFromTeacher._id;
        return hasNoClass && isNotFromTeacher;
    });
    
    const formik = useFormik({
        initialValues: teacher,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values, { resetForm }) => {
            const userDetails = JSON.parse(localStorage.getItem("userDetail"));
            const isInactive = values.status === 'inactive';
            
            // Show warning alert if status is Inactive
            if (isInactive) {
                const confirmMessage = teacher._id 
                    ? "Warning: Setting teacher status to Inactive will deactivate their login credentials (mobile number and password). They will not be able to log in. Do you want to continue?"
                    : "Warning: Creating teacher with Inactive status means their login credentials (mobile number and password) will be deactivated. They will not be able to log in. Do you want to continue?";
                
                if (!window.confirm(confirmMessage)) {
                    return; // User cancelled, don't submit
                }
            }
            
            const payload = {
                ...values,
                schooleId: userDetails.schooleId,
                status: values.status === 'active',
                classId: values.classId || null,
                sectionId: values.sectionId || null,
            };
            if (teacher._id) {
                TeacherService.upadeTeacher(payload).then((res) => {
                    handleClose();
                    getTeacherList();
                    resetForm();
                    if (isInactive) {
                        alert("Teacher Updated Successfully.\n\nNote: Teacher credentials (mobile number and password) have been deactivated. The teacher will not be able to log in until the status is changed back to Active.");
                    } else {
                        alert("Teacher Updated Successfully.");
                    }
                }).catch((err) => {
                    alert(err?.response?.data?.message || err?.response?.data?.error || "Failed to update teacher.");
                });
            }
            else {
                TeacherService.creteTeacher(payload).then((res) => {
                    getTeacherList();
                    resetForm();
                    handleClose();
                    if (isInactive) {
                        alert("Teacher Added Successfully.\n\nNote: Teacher credentials (mobile number and password) have been deactivated. The teacher will not be able to log in until the status is changed back to Active.");
                    } else {
                        alert("Teacher Added Successfully.");
                    }
                })
                    .catch((err) => {
                        alert(err?.response?.data?.message || "Failed to add teacher.");
                    });
            }
        },
    });

    return (

        <>
            <PageTitle title="Teacher" button={<Button
                variant="contained" onClick={() => handleOpen(true)}
                size="medium"
                color="secondary" style={{ backgroundColor: 'rgb(15 59 98)' }}> Add Teacher
            </Button>} />
            <Card style={{ padding: 14, marginBottom: 12, borderLeft: "4px solid rgb(15 59 98)" }}>
                <Typography style={{ fontWeight: 800, color: "rgb(15 59 98)", marginBottom: 6 }}>
                    Assign Class & Transfer – What it means
                </Typography>
                <Typography variant="body2" style={{ color: "#4b5563", lineHeight: 1.7 }}>
                    <strong>Assign Class</strong> is used to give a teacher access to one or more Class/Section combinations.
                    The teacher can then manage activities and student-related work for the assigned classes.
                </Typography>
                <Box mt={1}>
                    <Typography variant="body2" style={{ color: "#4b5563", lineHeight: 1.7 }}>
                        <strong>How Assign works</strong><br />
                        1) Click <strong>Assign Class</strong> on a teacher row.<br />
                        2) Select a <strong>Class</strong> and (optional) one or more <strong>Sections</strong>.<br />
                        3) Click <strong>Add More Class To Teacher</strong> to add multiple assignments.<br />
                        4) Click <strong>Save</strong> to update the teacher’s additional class/section access.
                    </Typography>
                </Box>
                <Box mt={1}>
                    <Typography variant="body2" style={{ color: "#4b5563", lineHeight: 1.7 }}>
                        <strong>Transfer</strong> is used when a Class needs to be moved from one teacher to another.
                        It shifts the class responsibility (and related records) to the selected teacher.
                    </Typography>
                    <Typography variant="body2" style={{ color: "#4b5563", lineHeight: 1.7, marginTop: 4 }}>
                        <strong>How Transfer works</strong><br />
                        1) Click <strong>Transfer</strong> for the teacher who currently owns the class.<br />
                        2) Select another teacher to receive the class.<br />
                        3) Click <strong>Transfer</strong> to complete.
                    </Typography>
                </Box>
            </Card>
            <Card sx={{ maxWidth: 345 }}>
                <Box   >
                   

                            <Grid container spacing={2} columns={12} style={{ margin: 10, }}  >
                                <Grid item xs={6} sm={6} md={4}  >
                                    <FormControl className={classes.formControl} fullWidth
                                    >
                                        <InputLabel id="demo-simple-select-label">Select Class</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            name="searchClassId"
                                            label="selectClass"


                                            onChange={e => { setSearchClassId(e.target.value); getTeacherList(e) }}
                                            value={searchClassId}
                                        >
                                            <MenuItem value="">
                                                <em>None</em>
                                            </MenuItem>

                                            {addClassList.map(({ _id, className }) => (
                                                <MenuItem key={_id} value={_id}>{className}

                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>

                                </Grid>
                           
                               
                                <Grid item xs={6} sm={6} md={4}>
                                    <Button style={{ backgroundColor: 'rgb(15 59 98)', color: 'white' }}
                                        type="button"

                                        onClick={() => onSubmit()} variant="contained"
                                    >
                                        Search</Button>
                                </Grid>
                               
                            </Grid>


                </Box>
            </Card>
              <br></br>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Widget title="" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
                                                <TableContainer component={Paper} style={{ maxHeight: 500 }}>

                        <Table  stickyHeader className="mb-0">
                            <TableHead >
                                <TableRow>
                                    {tableHeaders.map(key => (
                                        <StyledTableCell key={key}>{key}</StyledTableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {teacherList.map((teacher) => (
                                    <TableRow key={teacher._id}>
                                        <TableCell className="pl-3 fw-normal" >{teacher.teacherName}</TableCell>
                                        <TableCell className="pl-3 fw-normal" >
                                            {teacher.classId ? teacher.classId.className : ''}
                                        </TableCell>
                                        
                                        <TableCell className="pl-3 fw-normal" >
                                            {teacher.sectionId ? teacher.sectionId.sectionName : ''}
                                        </TableCell>
                                        <TableCell className="pl-3 fw-normal" >{teacher.address}</TableCell>
                                        <TableCell className="pl-3 fw-normal" >
                                            <span style={{
                                                color: (teacher.status === 'active' || teacher.status === true || teacher.status == null) ? '#4caf50' : '#f44336',
                                                fontWeight: 'bold',
                                                textTransform: 'capitalize',
                                            }}>
                                                {(teacher.status === 'active' || teacher.status === true || teacher.status == null) ? 'Active' : 'Inactive'}
                                            </span>
                                        </TableCell>
                                        <TableCell>
                                            <Button
                                                size="small"
                                                variant="outlined"
                                                style={{ backgroundColor: 'rgb(15 59 98)', color: 'white' }}
                                                onClick={() => openAssignClassDialog(teacher)}
                                            >
                                                Assign Class
                                            </Button>
                                        </TableCell>
                                        <TableCell>
                                            <EditIcon style={{ cursor: 'pointer' }} onClick={() => editTeacher(teacher)} >
                                            </EditIcon >
                                        </TableCell>
                                        <TableCell>
                                            <DeleteIcon style={{ cursor: 'pointer' }} onClick={() => deleteTeacher(teacher)} />
                                        </TableCell>
                                        <TableCell>
                                            {teacher.classId && (
                                                <Button
                                                    size="small"
                                                    variant="outlined"
                                                    style={{ backgroundColor: 'rgb(15 59 98)', color: 'white' }}
                                                    onClick={() => openTransferPopup(teacher)}
                                                >
                                                    Transfer
                                                </Button>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        </TableContainer>
                    </Widget>
                </Grid>
            </Grid>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Add Teacher</DialogTitle>
                <form onSubmit={formik.handleSubmit} >
                    <DialogContent style={{ width: 308 }}>
                        {/* <FormControl variant="standard" fullWidth="true" >
                            <InputLabel id="demo-simple-select-standard-label">Age</InputLabel>
                            <Select
                                labelId="demo-simple-select-standard-label"
                                id="className"
                                name="classId"
                                label="className"
                                value={formik.values.classId}
                                onChange={formik.handleChange}
                                error={formik.touched.classId && Boolean(formik.errors.classId)}
                                helperText={formik.touched.classId && formik.errors.classId}
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                {addClassList.map(({ _id, className }) => (
                                    <MenuItem key={_id} value={_id}>{className}
                                      
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl> */}
                        <TextField
                            InputProps={{ style: { width: 258 } }}
                            autoFocus
                            margin="dense"
                            id="teacherName"
                            name="teacherName"
                            label="Teacher Name"
                            type="text"
                            variant="standard"
                            value={formik.values.teacherName}
                            onChange={formik.handleChange}
                            error={formik.touched.teacherName && Boolean(formik.errors.teacherName)}
                            helperText={formik.touched.teacherName && formik.errors.teacherName}
                        />
                        <FormControl className={classes.formControl} fullWidth="true" style={{ marginTop: 8 }}>
                            <InputLabel id="demo-simple-select-label">Select Class (Optional)</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                name="classId"
                                label="Select Class (Optional)"
                                value={formik.values.classId || ''}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    formik.setFieldValue('classId', value);
                                    // reset section when class changes
                                    formik.setFieldValue('sectionId', '');
                                    getSectionListByClass(value);
                                }}
                                error={formik.touched.classId && Boolean(formik.errors.classId)}
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                {addClassList.map(({ _id, className }) => (
                                    <MenuItem key={_id} value={_id}>{className}</MenuItem>
                                ))}
                            </Select>
                            {formik.touched.classId && formik.errors.classId && (
                                <span style={{ color: '#f44336', fontSize: '0.75rem', marginTop: 4, display: 'block' }}>
                                    {formik.errors.classId}
                                </span>
                            )}
                        </FormControl>
                        <FormControl className={classes.formControl} fullWidth="true" style={{ marginTop: 8 }}>
                            <InputLabel id="teacher-section-select-label">Select Section (Optional)</InputLabel>
                            <Select
                                labelId="teacher-section-select-label"
                                id="teacher-section-select"
                                name="sectionId"
                                label="Select Section (Optional)"
                                value={formik.values.sectionId || ''}
                                onChange={formik.handleChange}
                                disabled={!formik.values.classId || sectionList.length === 0}
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                {sectionList.map(({ _id, sectionName }) => (
                                    <MenuItem key={_id} value={_id}>{sectionName}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <TextField
                            InputProps={{ style: { width: 258 } }}
                            margin="dense"
                            id="email"
                            name="email"
                            label="Email ID"
                            type="text"
                            variant="standard"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            error={formik.touched.email && Boolean(formik.errors.email)}
                            helperText={formik.touched.email && formik.errors.email}
                        />
                        <TextField
                            InputProps={{ style: { width: 258 }}}
                            margin="dense"
                            id="mobileNumber"
                            name="mobileNumber"
                            label="Mobile Number"
                            type="text"
                            variant="standard"
          
                            value={formik.values.mobileNumber}
                            onChange={formik.handleChange}
                            error={formik.touched.mobileNumber && Boolean(formik.errors.mobileNumber)}
                            helperText={formik.touched.mobileNumber && formik.errors.mobileNumber}
                           
                        />
                        <TextField
                            id="password"
                            label="Set Password"
                            type={showPassword ? "text" : "password"}
                            name="password"
                            value={formik.values.password}
                            onChange={formik.handleChange}
                            error={formik.touched.password && Boolean(formik.errors.password)}
                            helperText={formik.touched.password && formik.errors.password}
                            InputProps={{
                                style: { width: 258 },
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                        >
                                            {showPassword ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />
                        {/* <TextField
                            InputProps={{ style: { width: 258 } }}                         
                            margin="dense"
                            id="subject"
                            name="subject"
                            label="Subject"
                            type="text"
                            variant="standard"
                            value={formik.values.subject}
                            onChange={formik.handleChange}
                            error={formik.touched.subject && Boolean(formik.errors.subject)}
                            helperText={formik.touched.subject && formik.errors.subject}
                        /> */}
                        <TextField
                            InputProps={{ style: { width: 258 } }}
                            margin="dense"
                            id="qualification"
                            name="qualification"
                            label="Qualification"
                            type="text"
                            variant="standard"
                            value={formik.values.qualification}
                            onChange={formik.handleChange}
                            error={formik.touched.qualification && Boolean(formik.errors.qualification)}
                            helperText={formik.touched.qualification && formik.errors.qualification}
                        />
                        <TextField
                            InputProps={{ style: { width: 258 } }}
                            margin="dense"
                            id="address"
                            name="address"
                            placeholder="enter City Name "
                            label="address "
                            type="text"
                            variant="standard"
                            value={formik.values.address}
                            onChange={formik.handleChange}
                            error={formik.touched.address && Boolean(formik.errors.address)}
                            helperText={formik.touched.address && formik.errors.address}
                        />
                        
                        {/* <FormControl variant="standard" fullWidth>
                            <InputLabel id="demo-simple-select-standard-label">Attendence</InputLabel>
                            <Select
                                labelId="demo-simple-select-standard-label"
                                id="demo-simple-select-standard"
                                label="attendence"
                                name="attendence"
                                value={formik.values.attendence}
                                onChange={formik.handleChange}
                                error={formik.touched.attendence && Boolean(formik.errors.attendence)}
                                helperText={formik.touched.attendence && formik.errors.attendence}
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                <MenuItem value={true}>Present</MenuItem>
                                <MenuItem value={false}>Obsent</MenuItem>

                            </Select>
                        </FormControl> */}
                        <FormControl variant="standard" fullWidth>
                            <InputLabel id="demo-simple-select-standard-label">Status</InputLabel>
                            <Select
                                labelId="demo-simple-select-standard-label"
                                id="demo-simple-select-standard"
                                label="status"
                                name="status"
                                value={formik.values.status === true || formik.values.status === 'active' ? 'active' : 'inactive'}
                                onChange={formik.handleChange}
                                error={formik.touched.status && Boolean(formik.errors.status)}
                                helperText={formik.touched.status && formik.errors.status}
                            >
                                <MenuItem value="active">Active</MenuItem>
                                <MenuItem value="inactive">Inactive</MenuItem>
                            </Select>
                            {formik.touched.status && formik.errors.status && (
                                <span style={{ color: '#f44336', fontSize: '0.75rem', marginTop: 4, display: 'block' }}>
                                    {formik.errors.status}
                                </span>
                            )}
                            {(formik.values.status === 'inactive' || formik.values.status === false) && (
                                <span style={{ color: '#ff9800', fontSize: '0.75rem', marginTop: 4, display: 'block', fontWeight: 500 }}>
                                    ⚠️ Warning: Inactive status will deactivate teacher's login credentials (mobile number and password)
                                </span>
                            )}
                        </FormControl>
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button type="submit">Add</Button>
                    </DialogActions>
                </form>
            </Dialog>
            <Dialog open={assignOpen} onClose={handleAssignClose}>
                <DialogTitle>
                    Assign Class{assignTeacher ? ` - ${assignTeacher.teacherName}` : ''}
                </DialogTitle>
                <DialogContent style={{ width: 420 }}>
                    <Box style={{ marginBottom: 16, padding: 12, backgroundColor: 'rgba(0,0,0,0.04)', borderRadius: 4 }}>
                        <Typography variant="body2" color="textSecondary">
                            When you assign a class or section to this teacher, they will have <strong>create</strong>, <strong>edit</strong>, <strong>delete</strong>, and <strong>read</strong> access for activities and data in those classes.
                        </Typography>
                    </Box>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth size="small" variant="outlined">
                                <InputLabel id="assign-class-label">Class</InputLabel>
                                <Select
                                    labelId="assign-class-label"
                                    id="assign-class"
                                    value={assignClassId}
                                    onChange={handleAssignClassChange}
                                    label="Class"
                                >
                                    <MenuItem value=""><em>None</em></MenuItem>
                                    {addClassList.map((c) => (
                                        <MenuItem key={c._id} value={c._id}>{c.className}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth size="small" variant="outlined" disabled={!assignClassId || assignSectionList.length === 0}>
                                <InputLabel id="assign-section-label">Section (optional)</InputLabel>
                                <Select
                                    labelId="assign-section-label"
                                    id="assign-section"
                                    multiple
                                    value={assignSectionIds}
                                    onChange={handleAssignSectionChange}
                                    label="Section (optional)"
                                    renderValue={(selected) => {
                                        const ids = Array.isArray(selected) ? selected : [];
                                        const names = assignSectionList
                                            .filter((s) => ids.includes(s._id))
                                            .map((s) => s.sectionName);
                                        return names.join(', ');
                                    }}
                                >
                                    {assignSectionList.map((s) => (
                                        <MenuItem key={s._id} value={s._id}>
                                            {s.sectionName}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <Button
                                variant="contained"
                                size="small"
                                style={{ backgroundColor: 'rgb(15 59 98)', color: 'white' }}
                                onClick={handleAddOrUpdateAssignment}
                            >
                                {assignEditingIndex != null ? 'Update Assignment' : 'Add More Class To Teacher'}
                            </Button>
                        </Grid>
                        <Grid item xs={12}>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>Class</StyledTableCell>
                                        <StyledTableCell>Sections</StyledTableCell>
                                        <StyledTableCell align="right">Actions</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {assignTeacher && assignTeacher.classId && (
                                        <TableRow>
                                            <TableCell>
                                                {assignTeacher.classId && (assignTeacher.classId.className || assignTeacher.classId)}
                                            </TableCell>
                                            <TableCell>
                                                {assignTeacher.sectionId && (assignTeacher.sectionId.sectionName || assignTeacher.sectionId)
                                                    ? (assignTeacher.sectionId.sectionName || assignTeacher.sectionId)
                                                    : 'No section'}
                                            </TableCell>
                                            <TableCell align="right">
                                                <Typography variant="caption" style={{ color: '#c62828', fontWeight: 600 }}>
                                                    Primary (not editable)
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                    {assignments.length === 0 && !assignTeacher?.classId && (
                                        <TableRow>
                                            <TableCell colSpan={3}>
                                                <Typography variant="body2" color="textSecondary">
                                                    No additional classes assigned yet.
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                    {assignments.map((item, index) => (
                                        <TableRow key={index}>
                                            <TableCell>{item.class?.className || ''}</TableCell>
                                            <TableCell>
                                                {item.sectionId && item.sectionId.length > 0
                                                    ? item.sectionId.map((s) => s.sectionName).join(', ')
                                                    : 'No section'}
                                            </TableCell>
                                            <TableCell align="right">
                                                <IconButton size="small" onClick={() => handleEditAssignment(index)}>
                                                    <EditIcon fontSize="small" />
                                                </IconButton>
                                                <IconButton size="small" onClick={() => handleDeleteAssignment(index)}>
                                                    <DeleteIcon fontSize="small" />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleAssignClose}>Cancel</Button>
                    <Button
                        onClick={handleAssignSave}
                        color="primary"
                        variant="contained"
                        style={{ backgroundColor: 'rgb(15 59 98)' }}
                        disabled={!assignTeacher}
                    >
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={transferOpen} onClose={handleTransferClose}>
                <DialogTitle>Transfer class to another teacher</DialogTitle>
                <DialogContent style={{ width: 308 }}>
                    <Box style={{ marginBottom: 16, padding: 12, backgroundColor: 'rgba(0,0,0,0.04)', borderRadius: 4 }}>
                        <Typography variant="body2" color="textSecondary">
                            When you transfer a class, all data (assignments, activities, and related records) for that class will move to the teacher you select below.
                        </Typography>
                    </Box>
                    {transferFromTeacher && (
                        <p style={{ marginBottom: 16 }}>
                            Transfer class <strong>{transferFromTeacher.classId && (transferFromTeacher.classId.className || '')}</strong> from <strong>{transferFromTeacher.teacherName}</strong> to:
                        </p>
                    )}
                    <FormControl className={classes.formControl} fullWidth>
                        <InputLabel id="transfer-teacher-label">Select teacher (no class assigned)</InputLabel>
                        <Select
                            labelId="transfer-teacher-label"
                            id="transfer-teacher-select"
                            value={transferToTeacherId}
                            onChange={(e) => setTransferToTeacherId(e.target.value)}
                            label="Select teacher (no class assigned)"
                        >
                            <MenuItem value="">
                                <em>None</em>
                            </MenuItem>
                            {teachersWithoutClass.map((t) => (
                                <MenuItem key={t._id} value={t._id}>{t.teacherName}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleTransferClose}>Cancel</Button>
                    <Button onClick={handleTransferSubmit} color="primary" variant="contained" style={{ backgroundColor: 'rgb(15 59 98)', color: 'white' }} disabled={!transferToTeacherId}>
                        Transfer
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}


